import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import RoomForm from '@/features/rooms/components/forms/room-form'

export const Route = createFileRoute(
  '/_authenticated/dashboard/rooms/new',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-4">
          <Link to="/dashboard/rooms">
            <Button size="icon" variant="outline" className="rounded-full">
              <ArrowLeft />
            </Button>
          </Link>
        </div>
        <CardTitle>
          Create A New Room
        </CardTitle>
        <CardDescription>
          Use this form to enter a new room into the system
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RoomForm />
      </CardContent>
    </Card>
  )
}
